import { Toolbar as StandardToolbar, ToolbarItem as StandardItem } from '@emorg-prd/standard-react';
import React, { ReactNode } from 'react';

export type ToolbarItemWidth = 'auto' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const widthValues: Record<Exclude<ToolbarItemWidth, 'auto'>, string> = {
	xs: '10%',
	sm: '20%',
	md: '30%',
	lg: '40%',
	xl: '50%',
};

interface ToolbarItemProps extends React.ComponentProps<typeof StandardItem> {
	right?: boolean;
	className?: string;
	width?: ToolbarItemWidth;
}
export const ToolbarItem: React.FC<ToolbarItemProps> = ({ width, className, style, ...props }) => {
	const widthStyle: React.CSSProperties = width && width !== 'auto' ? { width: widthValues[width] } : {};
	return (
		<StandardItem optionalClass={className} alignRight={props.right} style={{ ...widthStyle, ...style }} {...props}>
			{props.children}
		</StandardItem>
	);
};

interface ToolbarProps extends React.ComponentProps<typeof StandardToolbar> { }

export const Toolbar: React.FC<ToolbarProps> = (props) => {
	return <StandardToolbar {...props}>{props.children}</StandardToolbar>;
};
